<template>
  <!-- 查看分类文档 -->
  <div class="viewDoc">
    <!-- 页头 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增帮助文档</el-button
        >
      </template>
    </page-bar>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        label="编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="文章名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="level"
        label="级别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "viewDoc",
  data() {
    return {
      id: "",
      /**表格数据 */
      // {
      //   id:"编号",
      //   name:"文章名称",
      //   level:"级别",
      //   sort:"排序"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },
  mounted() {
    //接收role传递参数
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      this.id = prams.id;
      this.getTableData();
    }
  },
  methods: {
    updata() {
      if (this.id) {
        this.getTableData();
      }
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**获取数据 */
    getTableData() {
      let data = {
        type: "GetGoodsCategory_sonhelp",
        erid: this.id,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Category"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data.map((item) => ({
              id: item.id,
              name: item.title,
              level: item.class_layer,
              sort: item.sort_id,
            }));
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**添加/编辑文档 */
    handleAdd(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify({ id: row.id }));
      }
      this.$router.push({
        path: "editDoc",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    // 删除文档
    handleDel(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            type: "DltCategory",
            id: row.id,
          };
          let proc = "Proc_Admin_Category"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "goods/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.viewDoc {
  width: 100%;
  height: 100%;
}
</style>
